export const PARENT_PATH = '/groups';
